 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import AD_CARD from '@/components/ad_card'
 import DEDICATION from '@/components/dedication'
 import TITLEPAGE from '@/components/titlepage'
 import COPYRIGHT from '@/components/copyright'
 import EPIGRAPH from '@/components/epigraph'
 import PREFACE001 from '@/components/preface001'
 import TOC from '@/components/toc'
 import INTRODUCTION from '@/components/introduction'
 import HALFTITLE from '@/components/halftitle'
 import CHAPTER001 from '@/components/chapter001'
 import CHAPTER002 from '@/components/chapter002'
 import CHAPTER003 from '@/components/chapter003'
 import CHAPTER004 from '@/components/chapter004'
 import CHAPTER005 from '@/components/chapter005'
 import CHAPTER006 from '@/components/chapter006'
 import CHAPTER007 from '@/components/chapter007'
 import CHAPTER008 from '@/components/chapter008'
 import CHAPTER009 from '@/components/chapter009'
 import CHAPTER010 from '@/components/chapter010'
 import CHAPTER011 from '@/components/chapter011'
 import ACKNOWLEDGMENTS from '@/components/acknowledgments'
 import AFTERWORD from '@/components/afterword'
 import APPENDIX001 from '@/components/appendix001'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/toc",
 			"name" : "toc",
 			"component" : TOC
 		},
 		{
 			"path" : "/introduction",
 			"name" : "introduction",
 			"component" : INTRODUCTION
 		},
 		{
 			"path" : "/halftitle",
 			"name" : "halftitle",
 			"component" : HALFTITLE
 		},
 		{
 			"path" : "/chapter001",
 			"name" : "chapter001",
 			"component" : CHAPTER001
 		},
 		{
 			"path" : "/chapter002",
 			"name" : "chapter002",
 			"component" : CHAPTER002
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js